import useSWR from "swr";

import { api, createStyleDetailsEanUrl } from "@is/services/api";
import { Style } from "@is/types";

export const useStyleDetailsEan = (ean: string) => {
  const url = createStyleDetailsEanUrl(ean);

  const { data, isLoading, error } = useSWR(!!ean && url, api.get, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
  });

  return {
    data: data as Style,
    isLoading,
    error,
  };
};
